export const MANUALES_POR_MODULO = {
  ordenesProduccionPU: [
    { key: "ordenes", titulo: "Órdenes de Producción", categoria: "Producción", descripcion: "Alta, edición, planeación y seguimiento de órdenes de producción por etapas.", archivo: "manual-ordenes-produccion-pu.html" },
  ],
  configuracionOrdenesProduccionPU: [
    { key: "configuracion", titulo: "Configuración de Órdenes de Producción", categoria: "Producción", descripcion: "Campos de la plantilla y etapas de las órdenes de producción.", archivo: "manual-configuracion-ordenes-produccion-pu.html" },
  ],
  matrices: [
    { key: "matrices", titulo: "Matrices", categoria: "Producción", descripcion: "Creación y administración de matrices de productos terminados.", archivo: "manual-matrices.html" },
  ],
  listaDeMateriales: [
    { key: "bom", titulo: "Lista de Materiales (BOM)", categoria: "Producción", descripcion: "Define la lista de materia prima necesaria para fabricar un producto.", archivo: "manual-bom.html" },
  ],
  presupuestosPU: [
    { key: "presupuestos", titulo: "Presupuestos PU", categoria: "Producción", descripcion: "Presupuestos de precios unitarios y su paso a órdenes de producción.", archivo: "manual-presupuestos-pu.html" },
  ],
  almacenProduccionPU: [
    { key: "almacen", titulo: "Almacén de Producción", categoria: "Inventarios", descripcion: "Entrega de material a las órdenes de producción desde almacén.", archivo: "manual-almacen.html" },
  ],
  dosPasos: [
    { key: "dosPasos", titulo: "Verificación en dos pasos", categoria: "Seguridad", descripcion: "Activa y administra la verificación en dos pasos de tu cuenta.", archivo: "manual-verificacion-en-dos-pasos.html" },
  ],
  iaAdministrador: [
    { key: "iaAdmin", titulo: "Manual del administrador de IA", categoria: "IA", descripcion: "Administración del acceso de usuarios a asistentes de IA.", archivo: "manual-mcp-administrador.html" },
  ],
  iaUsuario: [
    { key: "iaUsuario", titulo: "Manual de usuario de IA", categoria: "IA", descripcion: "Cómo conectar y usar BIWO ERP desde un asistente de IA.", archivo: "manual-mcp-usuario.html" },
  ],
  soporteUsuario: [
    { key: "soporteUsuario", titulo: "Manual de usuario de Soporte", categoria: "Soporte", descripcion: "Levantar reportes, platicar en el chat y dar seguimiento a cada caso.", archivo: "manual-soporte-usuario.html" },
  ],
  soporteAdministrador: [
    { key: "soporteUsuario", titulo: "Manual de usuario de Soporte", categoria: "Soporte", descripcion: "Levantar reportes, platicar en el chat y dar seguimiento a cada caso.", archivo: "manual-soporte-usuario.html" },
    { key: "soporteAdmin", titulo: "Manual del administrador de Soporte", categoria: "Soporte", descripcion: "Revisar, autorizar o atender en la empresa las peticiones de soporte.", archivo: "manual-soporte-administrador.html" },
  ],
};

export const MANUALES_NUEVOS = Object.values(MANUALES_POR_MODULO)
  .flat()
  .filter((m, i, lista) => lista.findIndex((x) => x.archivo === m.archivo) === i);

export const urlManual = (manual) => `${process.env.PUBLIC_URL}/manuales/${manual.archivo}`;

export const abrirManual = (manual) => window.open(urlManual(manual), "_blank", "noopener");
